import React from 'react';
import DomainListPage from '../components/domaines/DomainListPage';
import { ovhDomainListAdapter } from '../adapters/domainListAdapters';

const DomaineOvhPage = () => (
  <DomainListPage adapter={ovhDomainListAdapter} />
);

export default DomaineOvhPage;
